import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useRatioCache } from './cache'
import {
  type UnsavedRatioData,
  type RatioData,
  toResponseError,
  type RatioAddInput,
  type RatioAddSuccess,
} from '@terros/common'

export const useAddRatio = (): AddHookResponse<UnsavedRatioData, RatioData> => {
  const cache = useRatioCache()

  const mutation = useTantalimMutation<RatioAddInput, RatioAddSuccess>({
    url: '/ratio/add',
  })

  async function add(unsaved: UnsavedRatioData): Promise<RatioData> {
    try {
      const { ratio } = await mutation.mutateAsync({ ratio: unsaved })
      cache.updateItem(ratio)
      cache.clearReportColumns()
      return ratio
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
